/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: require('./Dialog'),
    slot: {
        content: ['html', [{
            'class': 'logistics-content',
            'data-state':nb.bind('logisticsState'),
            $html: [{
                'class': 'logistics-item',
                $html: [{
                    tag:'span',
                    'class': 'logistics-info',
                    $html: [{
                        'class': 'iconfont icon-chuangjiandingdan- icon-title'
                    }, {
                        'class': 'logistics-text',
                        $text:nb.bind('tit1')
                        // $text: '创建订单'
                    }]
                }, {
                    tag:'span',
                    'class': 'iconfont icon-youjiantou you-subtitle'
                }]
            }, {
                'class': 'logistics-item',
                $html: [{
                    tag:'span',
                    'class': 'logistics-info',
                    $html: [{
                        'class': 'iconfont icon-shouhuo1 icon-title'
                    }, {
                        'class': 'logistics-text',
                        $text:nb.bind('tit2')
                        // $text: '开始捡货'
                    }]
                }, {
                    tag:'span',
                    'class': 'iconfont icon-youjiantou you-subtitle'
                }]
            },{
                'class': 'logistics-item',
                $html:[{
                    tag:'span',
                    'class': 'logistics-info',
                    $html: [{
                        'class': 'iconfont icon-shouhuo icon-title'
                    }, {
                        'class':'logistics-text',
                        $text:nb.bind('tit3')
                        // $text:'拣货完成'
                    }]
                },{
                    tag:'span',
                    'class': 'iconfont icon-youjiantou you-subtitle'
                }]
            },{
                'class': 'logistics-item',
                $html:[{
                    tag:'span',
                    'class': 'logistics-info',
                    $html: [{
                        'class': 'iconfont icon-peisong1 icon-title'
                    }, {
                        'class':'logistics-text',
                        $text:nb.bind('tit4')
                        // $text:'配送中'
                    }]
                },{
                    tag:'span',
                    'class': 'iconfont icon-youjiantou you-subtitle'
                }]
            },{
                'class': 'logistics-item',
                $html:{
                    'class': 'logistics-info',
                    tag:'span',
                    $html: [{
                        'class': 'iconfont icon-dingdanwancheng1 icon-title'
                    },{
                        'class': 'logistics-text',
                        $text:nb.bind('tit5')
                        // $text:'订单完成'
                    }]
                }
            }]
        }]]
    },
    method: {
        init: function () {

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/modal/Logistics.js
// module id = 171
// module chunks = 3 8